/**
 * Menu items for the floating-bar Duplicate dropdown. Keep labels action-first
 * so the opened menu still reads as duplicate/copy behavior.
 */
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { DuplicateNodeMode } from '../../duplicateNodeData'
import type { ToolbarMenuItem } from './AgentNodeToolbar'

export function useDuplicateMenuItems(
  handleDuplicate: (mode: DuplicateNodeMode, originalName: string) => void,
  originalName: string,
): ToolbarMenuItem[] {
  const { t } = useTranslation('canvas')
  return useMemo(
    () => [
      {
        key: 'duplicate-current-variant',
        label: t('nodeDuplicateMenu.currentVariant'),
        onClick: () => handleDuplicate('current-variant', originalName),
      },
      {
        key: 'duplicate-all-history',
        label: t('nodeDuplicateMenu.allHistory'),
        onClick: () => handleDuplicate('all-history', originalName),
      },
    ],
    [t, handleDuplicate, originalName],
  )
}
